import { Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TimeAllocationType } from '../../../../api/work-periods-client/work-periods-client.type';
import { setSelectedAllocationType } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { useTimeAllocation } from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { Select } from '../../../../ui-library/select/select';
import { Text } from '../../../../ui-library/typography/typography';

const ALLOCATION_TYPE_OPTIONS = [
  { value: TimeAllocationType.Daily, label: 'Daily' },
  { value: TimeAllocationType.Weekly, label: 'Weekly' },
  { value: TimeAllocationType.BiWeekly, label: 'Bi-Weekly' },
  { value: TimeAllocationType.Monthly, label: 'Monthly' },
  { value: TimeAllocationType.Quarterly, label: 'Quarterly' },
];

/**
 * Sidebar filter that lets users override the auto-computed time allocation
 * type. When no explicit selection is made the dropdown reflects the value
 * auto-derived from the date range so the user always sees what is in effect.
 *
 * @returns {JSX.Element} Label + Select control
 */
export const AllocationTypeFilter = () => {
  const { t } = useTranslation();
  const effectiveAllocationType = useTimeAllocation();

  return (
    <Stack gap={8}>
      <Text size="small" weight="bold">
        {t('process_analysis.filters.allocation_type', { defaultValue: 'Allocation Type' })}
      </Text>
      <Select
        options={ALLOCATION_TYPE_OPTIONS}
        value={effectiveAllocationType}
        onChange={(value) => {
          if (Object.values(TimeAllocationType).includes(value as TimeAllocationType)) {
            setSelectedAllocationType(value as TimeAllocationType);
          }
        }}
        size="sm"
      />
    </Stack>
  );
};
